import React from 'react'
import T from 'prop-types'
import Joi from 'joi'
import Button from 'components/Button'
import Editorial from 'components/Editorial'
import getGenderText from 'apps/booking/helpers/getGenderText'

import Step from '../../components/Step'

export const validator = () =>
  Joi.object({
    rejection: Joi.string().required(),
  }).unknown(true)

// Show this step if:
// User is not eligible
export const rejectionPredicate = (values) => {
  return !values?.vaccinationId && !values?.isEligible && !values?.details?.on_behalf_of?.national_id
}

export default function Rejection({ changeStep, values, onChange }) {
  // Update and save answer
  const handleChange = (answer) => () => {
    onChange('rejection', answer)

    // Go to next step
    changeStep()
  }

  // Get saved answer
  const status = values?.rejection

  return (
    <Step title={getGenderText('Ønsker %s å sette deg opp som kandidat for vaksinasjon?', values)}>
      <Editorial>
        <p>
          {getGenderText(
            `
            %S kan ikke bestille time for vaksinasjon enda.
          `,
            values,
          )}
        </p>
        <p>
          {getGenderText(
            `
            %S kan her sette deg opp som kandidat for vaksinasjon og
            fylle inn noen enkle helseopplysninger. Det gjør at kommunen vet at %s ønsker
            vaksine, og samtidig får informasjon om hvilken risikogruppe %s tilhører. Rekkefølgen for
            koronavaksine er nøye definert av helsemyndighetene, og kommunen er pålagt å følge denne.
          `,
            values,
          )}
        </p>
        <Button
          arrow
          rounded
          onClick={handleChange('venteliste')}
          selected={status === 'venteliste'}
        >
          Jeg ønsker å stå på venteliste
        </Button>

        <p>
          {getGenderText(
            `
            Hvis du mener at %s allerede er godkjent for å kunne bestille time, eller %s ønsker å bli kontaktet av 
            kommunen så snart det åpner seg en ledig time, så ber vi deg kontakte kommunen og informere om dette. 
          `,
            values,
          )}
        </p>

        <br />
        <br />
      </Editorial>
    </Step>
  )
}

Rejection.propTypes = {
  changeStep: T.func.isRequired,
  values: T.object.isRequired,
  onChange: T.func.isRequired,
  orgUnit: T.shape({
    id: T.string.isRequired,
    slug: T.string.isRequired,
  }).isRequired,
}
